import { render } from "./PatientTagBadges.vue?vue&type=template&id=0fcbc2f3&scoped=true"
import script from "./PatientTagBadges.vue?vue&type=script&lang=js"
export * from "./PatientTagBadges.vue?vue&type=script&lang=js"

import "./PatientTagBadges.vue?vue&type=style&index=0&id=0fcbc2f3&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcbc2f3"]])

export default __exports__